import config from "../config/config";
import { userService } from "../services";

export const dynamiceForm = {
  saveTemplateType,
  getTemplateTypeListByTypeId,
  getActiveInActiveTemplateTypeListByTypeId,
  fetchGetCountryList,
  fetchSaveTempalte,
  fetchGetSaveTempalte,
  fetchCreateComunaction,
  fetchGetStateList,
  fetchGetCityList,
  fetchCompanyHeader,
  fetchCompanyHeaderUpdate,
  fetchExcelImport,
  fetchGetVendorsVehiclesDetailsById,
  saveClientAddress,
  updateClientAddress,
  fetchApiDataSync,
};

async function saveTemplateType(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.saveTemplateType}`;
  const response = await userService.post(apiEndpoint, payload);
  if (response.status === 201) {
    return response.data;
  } else {
    return response.response?.data || response.message;
  }
}

async function getTemplateTypeListByTypeId(payload) {
  const apiEndpoint = `${config.baseUrl}${config.apiName.getTemplateTypeListByTypeId}?id=${payload.id}&companyId=${payload.companyId}&siteId=${payload.siteId}`;
  const response = await userService.get(apiEndpoint);
  if (response?.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function getActiveInActiveTemplateTypeListByTypeId(payload) {
  const apiEndpoint = `${config.baseUrl}${
    config.apiName.getActiveInActiveTemplateTypeListByTypeId
  }?id=${payload.id}&companyId=${payload.companyId}${
    payload.siteId ? `&siteId=${payload.siteId}` : ""
  }`;
  const response = await userService.get(apiEndpoint);
  if (response?.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function fetchGetCountryList() {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.countryList;
    const response = await userService.get(apiEndpoint);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchSaveTempalte(payload) {
  try {
    const apiEndpoint = `${config.baseUrl}${config.apiName.saveTempalte}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchGetSaveTempalte(payload) {
  try {
    const apiEndpoint = `${
      config.baseUrl + config.apiName.getSaveTempalte
    }?companyId=${payload.companyId}&templateTypeId=${payload.templateTypeId}${
      payload.subTemplateTypeId
        ? `&subTemplateTypeId=${payload.subTemplateTypeId}`
        : ""
    }${payload.isForExport ? `&isForExport=${payload.isForExport}` : ""}${
      payload.siteId ? `&siteId=${payload.siteId}` : ""
    }`;
    const response = await userService.get(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchCreateComunaction(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.createcommunication;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchGetCityList(payload) {
  try {
    const apiEndpoint = `${config.baseUrl + config.apiName.CityList}/${
      payload.cityId
    }`;
    const response = await userService.get(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
async function fetchGetStateList(payload) {
  try {
    const apiEndpoint = `${
      config.baseUrl + config.apiName.stateList
    }?countryId=${payload.countryId}`;
    const response = await userService.get(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchCompanyHeader(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.companyHeader;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchCompanyHeaderUpdate(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.headerUpdate;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchExcelImport(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.ImportClient;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      console.log(response, "fghbjnkml");
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchGetVendorsVehiclesDetailsById(payload) {
  try {
    const apiEndpoint =
      config.baseUrl + config.apiName.getVendorsVehiclesDetailsById;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function saveClientAddress(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.saveClientAddress;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function updateClientAddress(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.updateClientAddress;
    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchApiDataSync(payload) {
  try {
    const apiEndPoint = `${
      config.baseUrl + config.apiName.getApiDataSync
    }?companyId=${payload.companyId}`;
    const response = await userService.get(apiEndPoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
